import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputContainerModule } from '../input-container/input-container.module';
import { TextareaComponent } from './textarea.component';

@NgModule({
  declarations: [TextareaComponent],
  imports: [CommonModule, InputContainerModule],
  exports: [InputContainerModule, TextareaComponent],
})
export class TextareaModule {}
